module.exports = __webpack_public_path__ + "static/media/solo5.e89ce92a.JPG";